import { TenantSubscription } from '../../entities/tenant/tenant';
import { BaseSecurityModule } from '../base.security.module';
import { SecurityModuleDomain, SecurityModuleName, SecurityRight } from '../security.module';


export enum PortalClientSecurityRight {
    CanAccessJobs = 60000,
    // CanAccessKnowledgeBase = 60001,
    CanAccessQuotes = 60006,
    CanAccessSites = 60007,
    ManageSites = 60008,
    // Replaced by Job / Site Activities Create and Edit (WBS-12875): out of the catalogue, no live screen reads it. Roles
    // may still store it and the release upgrade reads it once, so the id is never reused.
    ManageActivity = 60002,
    ViewInvoice = 60003,
    RequestNewJob = 60004,
    RequestNewQuote = 60005,
    ManageUsers = 60009,
    // 60010–60013 are shown as Site Jobs / Site Quotes / Site Invoices / Job Invoices View (WBS-12875): same meaning, so
    // stored roles need no migration.
    ViewJobsInSite = 60010,
    ViewQuotesInSite = 60011,
    ViewInvoicesInSite = 60012,
    ViewInvoicesInJob = 60013,
    CanAccessServices = 60014,
    CanAccessFiles = 60015,
    JobTasksView = 60016,
    JobSorsView = 60017,
    JobItemsView = 60018,
    JobAppointmentsView = 60019,
    JobFilesView = 60020,
    JobActivitiesView = 60021,
    JobActivitiesCreate = 60022,
    JobActivitiesEdit = 60023,
    SiteServicesView = 60024,
    SiteFilesView = 60025,
    SiteActivitiesView = 60026,
    SiteActivitiesCreate = 60027,
    SiteActivitiesEdit = 60028,
    SiteContactsView = 60029,
    SiteContactsCreate = 60030,
    SiteContactsEdit = 60031,
    SiteContactsDelete = 60032,
}

export class PortalClientSecurityModule extends BaseSecurityModule<PortalClientSecurityRight> {

    constructor() {

        super(
            SecurityModuleName.PortalClients,
            [
                { _id: PortalClientSecurityRight.CanAccessJobs, name: 'Access Jobs Board', basic: true },
                { _id: PortalClientSecurityRight.CanAccessQuotes, name: 'Access Quotes Board', basic: true },
                { _id: PortalClientSecurityRight.CanAccessSites, name: 'Access Sites', basic: true },
                { _id: PortalClientSecurityRight.ViewInvoice, name: 'Access Invoices Board', basic: true },
                { _id: PortalClientSecurityRight.CanAccessServices, name: 'Access Services Board', basic: true },
                { _id: PortalClientSecurityRight.CanAccessFiles, name: 'Access Files', basic: true },
                { _id: PortalClientSecurityRight.ManageSites, name: 'Create & Manage Sites', basic: false },
                { _id: PortalClientSecurityRight.RequestNewJob, name: 'Request New Job', basic: false },
                { _id: PortalClientSecurityRight.RequestNewQuote, name: 'Request New Quote', basic: false },
                { _id: PortalClientSecurityRight.ManageUsers, name: 'Manage Users', basic: false },
                { _id: PortalClientSecurityRight.JobTasksView, name: 'Job Tasks › View', basic: false },
                { _id: PortalClientSecurityRight.JobSorsView, name: 'Job SORs › View', basic: false },
                { _id: PortalClientSecurityRight.JobItemsView, name: 'Job Items › View', basic: false },
                { _id: PortalClientSecurityRight.JobAppointmentsView, name: 'Job Appointments › View', basic: false },
                { _id: PortalClientSecurityRight.ViewInvoicesInJob, name: 'Job Invoices › View', basic: false },
                { _id: PortalClientSecurityRight.JobFilesView, name: 'Job Files › View', basic: false },
                { _id: PortalClientSecurityRight.JobActivitiesView, name: 'Job Activities › View', basic: false },
                { _id: PortalClientSecurityRight.JobActivitiesCreate, name: 'Job Activities › Create', basic: false },
                { _id: PortalClientSecurityRight.JobActivitiesEdit, name: 'Job Activities › Edit', basic: false },
                { _id: PortalClientSecurityRight.SiteContactsView, name: 'Site Contacts › View', basic: false },
                { _id: PortalClientSecurityRight.SiteContactsCreate, name: 'Site Contacts › Create', basic: false },
                { _id: PortalClientSecurityRight.SiteContactsEdit, name: 'Site Contacts › Edit', basic: false },
                { _id: PortalClientSecurityRight.SiteContactsDelete, name: 'Site Contacts › Delete', basic: false },
                { _id: PortalClientSecurityRight.SiteServicesView, name: 'Site Services › View', basic: false },
                { _id: PortalClientSecurityRight.ViewQuotesInSite, name: 'Site Quotes › View', basic: false },
                { _id: PortalClientSecurityRight.ViewJobsInSite, name: 'Site Jobs › View', basic: false },
                { _id: PortalClientSecurityRight.ViewInvoicesInSite, name: 'Site Invoices › View', basic: false },
                { _id: PortalClientSecurityRight.SiteFilesView, name: 'Site Files › View', basic: false },
                { _id: PortalClientSecurityRight.SiteActivitiesView, name: 'Site Activities › View', basic: false },
                { _id: PortalClientSecurityRight.SiteActivitiesCreate, name: 'Site Activities › Create', basic: false },
                { _id: PortalClientSecurityRight.SiteActivitiesEdit, name: 'Site Activities › Edit', basic: false },
            ] as SecurityRight<PortalClientSecurityRight>[],
            SecurityModuleDomain.Portals
        );

        this.plan = TenantSubscription.Custom;
    }

}
